import type { App } from '../app/App';
import { download, showShareCode } from '../game/scenes/notebook/tabs';
import { monsterToDTO } from '../game/systems/monsters';
import type { Monster } from '../game/systems/model';
import { addMemory } from '../game/systems/progression';
import { ensureOnline } from './session';
import { t } from '../i18n';
import { ensureDrawingRules } from '../ui/drawingRules';

/** Share a monster: server share code when online, a .json file otherwise. */
export async function shareMonster(app: App, m: Monster): Promise<void> {
  if (m.drawing?.strokes.length && !(await ensureDrawingRules(app))) return;
  const dto = monsterToDTO(m);
  const markShared = (code?: string): void =>
    app.store.update(['monsters', 'quests', 'memories'], (s) => {
      s.counters.shares++;
      const own = s.monsters.find((x) => x.id === m.id);
      if (own && code) own.shareCode = code;
      addMemory(s, { kind: 'friend', title: t('Shared {name}', { name: m.name }), text: code ? t('Share code {code}', { code }) : t('Saved as a file for a friend.'), sticker: 'heart' });
    });
  if (await ensureOnline(app)) {
    try {
      const res = await app.api.shareMonster(dto);
      markShared(res.code);
      await showShareCode(app, m.name, res.code);
      return;
    } catch (err) {
      app.toast(err instanceof Error ? err.message : t('Share failed'), 'error');
    }
  }
  download(`${m.name.replace(/[^a-z0-9]+/gi, '-').toLowerCase() || 'monster'}.paperlegend.json`, JSON.stringify(dto));
  markShared();
  app.toast(t('Server offline — saved a monster file you can send to a friend instead.'), 'info');
}
